import { ButtonProps } from '@lyearn/ui';

import { AISuggestionsTypographyType } from '../types';

export const MAX_SUGGESTIONS_COUNT = 5;

export const AI_LIST_ANIMATION = {
  animate: { height: 'auto', opacity: 1 },
  exit: { height: 0, opacity: 0 },
  initial: { height: 0, opacity: 0 },
  transition: {
    layout: {
      type: 'spring',
      bounce: 0.4,
    },
  },
};

// use https://colors.artyclick.com/color-name-finder/ for inspiration ;)
export const AI_COLORS = {
  royalBlue: '#5a27ee',
  chalkPink: '#f7e7fd',
  fuchsiaPink: '#d62bda',
  lilacPink: '#ba4fdf',
  lavenderBlue: '#7e5be7',
  neonPurple: '#BE0EFC',
  barney: '#BB01BF',
} as const;

export const SUGGESTION_LIST_STYLES = {
  small: {
    root: 'px-12',
  },
  medium: {
    root: 'px-16',
  },
  large: {
    root: 'px-20',
  },
};

export const LIST_ITEM_STYLES = {
  small: {
    root: 'p-8 ps-10',
  },
  medium: {
    root: 'py-8 pe-10 ps-12',
  },
  large: {
    root: 'py-8 pe-10 ps-12',
  },
};

export const FORM_ASK_AI_STYLES: AISuggestionsTypographyType = {
  heading: 'heading-xs',
  suggestion: {
    variant: 'body-short-01',
    checkboxSize: 'medium',
  },
};

export const WIDE_SUGGESTIONS_STYLES: AISuggestionsTypographyType = {
  heading: 'heading-xxs',
  suggestion: {
    variant: 'body-short-02',
    checkboxSize: 'medium',
  },
};

export const HEADER_STYLES = {
  small: {
    root: 'pt-8 pe-8 pb-4 ps-16',
  },
  medium: {
    root: 'pt-12 pe-12 pb-16 ps-24',
  },
  large: {
    root: 'pt-12 pe-12 pb-20 ps-28',
  },
};

export const FOOTER_CONFIG: {
  [key in string]: {
    className: string;
    variant: string;
    btnSize: ButtonProps['size'];
  };
} = {
  small: {
    className: 'p-12 ps-16',
    variant: 'tooltip',
    btnSize: 'x-small',
  },
  medium: {
    className: 'py-16 ps-24 pe-16',
    variant: 'default',
    btnSize: 'small',
  },
  large: {
    className: 'py-16 ps-24 pe-16',
    variant: 'default',
    btnSize: 'small',
  },
};
